import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import _ from "lodash";
import { BreadcrumbNavigationService } from "../services/breadcrumb-navigation.service";

@Injectable({
    providedIn: "root"
})
export class BreadcrumbNavigationGuard  {
    private readonly breadcrumbService = inject(BreadcrumbNavigationService);

    canActivateChild(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
        const path = route.pathFromRoot;
        this.breadcrumbService.updateLinks(
            _.initial(path),
            route
        );
        return true;
    }
}
